import { render, staticRenderFns } from "./CreditIcon.vue?vue&type=template&id=1c56f84e&"
import script from "./CreditIcon.vue?vue&type=script&lang=js&"
export * from "./CreditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports